import { get } from "http";
import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";


export function useReviewRatingApi() {
  const callApi = useApiCall();

  const getReviewSummary = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.REVIEW.GET_REVIEW_SUMMARY, data, onSuccess, onError);
  }

  const getReviewList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.REVIEW.REVIEW_LIST, data, onSuccess, onError);
  }


  const getRatingSummary = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.RATING.RATING_SUMMARY, data, onSuccess, onError);
  }

  return {
    getReviewSummary,
    getReviewList,
    getRatingSummary,
  };
}
